module.exports = __webpack_public_path__ + "static/media/profilepic.d9c8ac89.jpg";